import { render, staticRenderFns } from "./loose-tea.vue?vue&type=template&id=5acc9a90&"
import script from "./loose-tea.vue?vue&type=script&lang=js&"
export * from "./loose-tea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports